import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

window.addEventListener("load", () => {

  gsap.utils.toArray(".gs-fade > *").forEach((section) => {
    gsap.from(section, {
      scrollTrigger: {
        trigger: section,
        start: '-50px bottom',
        end: 'bottom',
        toggleActions: "play complete complete reset",
      },
      autoAlpha: 0,
      duration: 1,
      y: '50px'
    });
  });

  gsap.from('#przegladaj-decoration', {
    scrollTrigger: { trigger: '#przegladaj-neuroprzewodnik', scrub: 1 }, y: 500
  });

  gsap.from('#posluchaj-decoration', {
    scrollTrigger: { trigger: '#posluchaj', scrub: 1 }, y: 500
  });

  gsap.from('#inicjatywy-i-dzialania-decoration-1', {
    scrollTrigger: { trigger: '#inicjatywy-i-dzialania', scrub: 1 }, xPercent: -50
  });

  gsap.from('#inicjatywy-i-dzialania-decoration-2', {
    scrollTrigger: { trigger: '#inicjatywy-i-dzialania', scrub: 1 }, xPercent: 50
  });

  gsap.from('#inicjatywy-i-dzialania-decoration-3', {
    scrollTrigger: { trigger: '#inicjatywy-i-dzialania', scrub: 1 }, y: -500
  });

  gsap.set('#boys', {
  xPercent: 50
});

gsap.to('#boys', {
  scrollTrigger: {
    trigger: '#boys',
    start: 'top bottom',
    end: 'bottom bottom',
    scrub: 1
  },
  xPercent: 0,
  ease: 'none'
});

});
